module.exports = __webpack_public_path__ + "static/media/hero-section-image.dcaa66fd.jpg";